var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 5.875V9.8125",
    stroke: "#007AFF",
    strokeWidth: 0.84375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 7.5625V9.8125M6.1875 7.5625C6.1875 6.63049 6.94299 5.875 7.875 5.875C8.80701 5.875 9.5625 6.63049 9.5625 7.5625V9.8125M6.1875 7.5625V5.875",
    stroke: "#007AFF",
    strokeWidth: 0.84375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94201 4.1875H3.93695",
    stroke: "#007AFF",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.40625 7C1.40625 4.48093 1.40625 3.2214 2.18882 2.43882C2.9714 1.65625 4.23093 1.65625 6.75 1.65625C9.26904 1.65625 10.5286 1.65625 11.3112 2.43882C12.0938 3.2214 12.0938 4.48093 12.0938 7C12.0938 9.51904 12.0938 10.7786 11.3112 11.5612C10.5286 12.3438 9.26904 12.3438 6.75 12.3438C4.23093 12.3438 2.9714 12.3438 2.18882 11.5612C1.40625 10.7786 1.40625 9.51904 1.40625 7Z",
    stroke: "#007AFF",
    strokeWidth: 0.84375,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.db8404feeea26c8ceba0a7fbd4b74060.svg";
export { ForwardRef as ReactComponent };